import { gql } from '@apollo/client'

export default gql`
  query GetBattlePassPrizeHistories(
    $filterInput: GetBattlePassPrizeHistoriesInput!
    $pagingInput: PagingInput
  ) {
    getBattlePassPrizeHistories(
      filterInput: $filterInput
      pagingInput: $pagingInput
    ) {
      edges {
        node {
          ... on BattlePassLuckyDrawHistory {
            seasonID
            drawDate
            prizeItem {
              prizeAssetName
              itemQty
            }
            useKeyAssetName
          }
        }
      }
      pageInfo {
        totalCount
      }
    }
  }
`
